import { useSeo, SITE_NAME } from '@/lib/seo';
import { Section } from '@/components/layout/Section';

/**
 * Placeholder Privacy Policy page. The final legal text must be provided by
 * the customer or their DPO. Content below is clearly labelled as draft.
 */
export default function Privacy() {
    useSeo({
        title: `${SITE_NAME} — Informativa sulla privacy`,
        description: "Informativa ai sensi del Regolamento UE 2016/679 (GDPR) sul trattamento dei dati personali raccolti tramite il sito Floreal Atelier del Fiore.",
    });

    return (
        <>
            <section className="pt-32 sm:pt-40 pb-6">
                <div className="container-atelier max-w-3xl">
                    <p className="eyebrow mb-4">Privacy</p>
                    <h1 className="font-serif text-4xl sm:text-5xl leading-[1.05] tracking-tight">
                        Informativa sul trattamento dei dati
                    </h1>
                    <p className="mt-4 text-sm text-muted-foreground">
                        Ultimo aggiornamento: 27/07/2026 · <span className="italic">Versione preliminare — contenuti da completare con il proprio consulente legale/DPO</span>
                    </p>
                </div>
            </section>

            <Section className="pt-6" data-testid="privacy-content">
                <article className="prose prose-neutral max-w-3xl mx-auto text-[15px] leading-relaxed [&_h2]:font-serif [&_h2]:text-2xl [&_h2]:mt-8 [&_h2]:mb-3 [&_p]:mb-4 [&_li]:mb-1">
                    <h2>1. Titolare del trattamento</h2>
                    <p>
                        Floreal Atelier del Fiore — Via Unione 3, 22074 Lomazzo (CO) — email
                        <a href="mailto:contact@florealworld.it" className="text-atelier-sage-ink"> contact@florealworld.it</a>.
                    </p>

                    <h2>2. Dati raccolti</h2>
                    <p>Attraverso i form del sito raccogliamo:</p>
                    <ul>
                        <li>Nome, cognome</li>
                        <li>Indirizzo email</li>
                        <li>Numero di telefono</li>
                        <li>Contenuto del messaggio o della richiesta</li>
                        <li>Data e dettagli di eventuali iscrizioni a eventi/workshop</li>
                    </ul>

                    <h2>3. Finalità del trattamento</h2>
                    <p>
                        I dati vengono utilizzati esclusivamente per rispondere alle richieste ricevute,
                        gestire iscrizioni ad eventi/workshop e fornire i servizi richiesti.
                    </p>

                    <h2>4. Base giuridica</h2>
                    <p>
                        Il trattamento avviene sulla base del consenso liberamente espresso dall'interessato
                        al momento della compilazione dei form (art. 6 lett. a GDPR).
                    </p>

                    <h2>5. Conservazione</h2>
                    <p>
                        I dati sono conservati per il tempo necessario a evadere la richiesta e comunque non
                        oltre 24 mesi, salvo diverse esigenze contabili/legali.
                    </p>

                    <h2>6. Comunicazione a terzi</h2>
                    <p>
                        I dati non vengono ceduti a terzi. Vengono utilizzati esclusivamente da fornitori
                        tecnici che ci consentono di erogare il servizio (es. Resend, invio email).
                    </p>

                    <h2>7. Diritti dell'interessato</h2>
                    <p>
                        L'utente può in ogni momento richiedere accesso, rettifica, cancellazione o portabilità
                        dei propri dati inviando una richiesta a <a href="mailto:contact@florealworld.it" className="text-atelier-sage-ink">contact@florealworld.it</a>.
                    </p>

                    <h2>8. Cookie</h2>
                    <p>
                        Il sito utilizza cookie tecnici necessari e, previo consenso, cookie funzionali per
                        migliorare l'esperienza di navigazione. La gestione dei cookie è disponibile tramite
                        il banner presente al primo accesso, ripescabile dal footer.
                    </p>

                    <p className="mt-10 text-sm italic text-muted-foreground border-t border-border pt-4">
                        <strong>Nota:</strong> il testo di questa informativa è preliminare e deve essere completato/verificato
                        con un consulente privacy prima della pubblicazione definitiva.
                    </p>
                </article>
            </Section>
        </>
    );
}
